import { MOKA_SERVICE_HOST } from '../constants';

const MOKA_BUSINESS_SERVICE = `${MOKA_SERVICE_HOST}/business-service`;

export const BANK_LIST = `${MOKA_BUSINESS_SERVICE}/v1/business/banks`;
export const BUSINESS_BANK_ACCOUNTS = `${MOKA_BUSINESS_SERVICE}/v1/business/bank-accounts`;
export const BUSINESS_BANK_ACCOUNT = `${MOKA_BUSINESS_SERVICE}/v1/business/bank-account`;
export const UPDATE_BUSINESS_BANK_ACCOUNTS = businessBankAccId =>
  `${MOKA_BUSINESS_SERVICE}/v1/business/bank-account/${businessBankAccId}`;
export const BUSINESS_BANK_ACCOUNTS_BY_KEYWORD = keyword =>
  `${MOKA_BUSINESS_SERVICE}/v1/business/bank-accounts?q=${keyword}`;
export const LINK_BUSINESS_BANK_ACCOUNTS_TO_OUTLET = `${MOKA_BUSINESS_SERVICE}/v1/business/link`;
export const UNLINK_BUSINESS_BANK_ACCOUNTS_TO_OUTLET = `${MOKA_BUSINESS_SERVICE}/v1/business/unlink`;

export const CREATE_BANK_ACCOUNTS = `${MOKA_BUSINESS_SERVICE}/v3/businesses/bank-accounts`;
export const UPDATE_BANK_ACCOUNTS = bankAccountId =>
  `${MOKA_BUSINESS_SERVICE}/v3/businesses/bank-accounts/${bankAccountId}`;
export const DELETE_BANK_ACCOUNTS = bankAccountId =>
  `${MOKA_BUSINESS_SERVICE}/v3/businesses/bank-accounts/${bankAccountId}`;
export const GET_BANK_ACCOUNT_ACTIVITY_LOGS = (page, size) =>
  `${MOKA_BUSINESS_SERVICE}/v3/businesses/bank-account-activity-logs?page=${page}&size=${size}`;
